import appConstants from '../../../constants';
import { KEYS } from '../../../l18n/constants';
import { useL18nContext } from '../ContextProvider/L18n';
import computeTagName from '../../../utils/computeTagName';
import computeClassName from '../../../utils/computeClassName';
import handleEventClick from "../../../utils/handleEventClick";
import CCIconChevronRight16x16 from "../../libs/CiscoCore/Icon/Chevron/Right/16x16";

const constants = Object.freeze({
  CLASSNAME_BASE: '',
  TAG_DEFAULT: 'nav'
});

const propsDefaults = Object.freeze({
  currentPageIndex: 1,
  recordCountPerPage: appConstants.RECORD_COUNT_PER_PAGE,
  totalRecordCount: 0,
  previousPageFn: null,
  nextPageFn: null,
  tag: constants.TAG_DEFAULT
});

export default function Pagination(
  {
    currentPageIndex =propsDefaults.currentPageIndex,
    recordCountPerPage = propsDefaults.recordCountPerPage,
    totalRecordCount = propsDefaults.totalRecordCount,
    previousPageFn = propsDefaults.previousPageFn,
    nextPageFn = propsDefaults.nextPageFn,
    className = '',
    tag = propsDefaults.tag
  }) {

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const ComputedComponentTagName = computeTagName(tag, constants.TAG_DEFAULT);

  const { getTranslationFor } = useL18nContext();
  const translatedBackLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_BACK);
  const translatedNextLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_NEXT)

  let validCurrentPageIndex = currentPageIndex < 1 ? 1 : currentPageIndex;
  let validRecordCountPerPage = recordCountPerPage < 1 ? 1 : recordCountPerPage;
  let validTotalRecordCount = totalRecordCount < 0 ? 0 : totalRecordCount;

  const computedRecordFrom = ((validCurrentPageIndex - 1) * validRecordCountPerPage) + 1;
  let computedRecordTo = computedRecordFrom + (validRecordCountPerPage - 1);
  if (computedRecordTo > validTotalRecordCount) {
    computedRecordTo = validTotalRecordCount;
  }
  const computedPreviousPageLinkClickFn = handleEventClick(previousPageFn);
  const computedNextPageLinkClickFn = handleEventClick(nextPageFn, totalRecordCount);
  const totalPageCount = Math.ceil(validTotalRecordCount / validRecordCountPerPage);

  return (
    <ComputedComponentTagName className={computedClassName}>
      <ul className="list-none flex flex-row items-center justify-center">
        <li className="flex flex-row items-center justify-center">
          {
            validCurrentPageIndex === 1 ?
              <span className="text-cc-body-medium sm:text-cc-body-large transition-colors duration-200 ease-linear group inline-flex items-center text-cc-muted-contrast font-semibold">
                <CCIconChevronRight16x16 aria-hidden="true" className="w-3 h-3 md:w-4 md:h-4 transform-gpu -rotate-180"/>
                <span className="ml-cc-0.5char transition-colors duration-200 border-b border-transparent">{translatedBackLabel}</span>
              </span> :
              <a href="/"
                 className="text-cc-body-medium sm:text-cc-body-large transition-colors duration-200 ease-linear group inline-flex items-center text-cc-accent font-semibold hover:text-cc-accent-60"
                 onClick={computedPreviousPageLinkClickFn}>
                <CCIconChevronRight16x16 aria-hidden="true" className="w-3 h-3 md:w-4 md:h-4 transform-gpu -rotate-180"/>
                <span className="ml-cc-0.5char transition-colors duration-200 border-b border-transparent group-hover:border-cc-accent">{translatedBackLabel}</span>
              </a>
          }
        </li>
        <li className="flex flex-row items-center justify-center mx-8 text-cc-body-medium sm:text-cc-body-large text-cc-primary-contrast">{computedRecordFrom} - {computedRecordTo}</li>
        <li className="flex flex-row items-center justify-center">
          {
            validCurrentPageIndex >= totalPageCount ?
              <span className="text-cc-body-medium sm:text-cc-body-large transition-colors duration-200 ease-linear group inline-flex items-center text-cc-muted-contrast font-semibold">
                <span className="transition-colors duration-200 border-b border-transparent">{translatedNextLabel}</span>
                <CCIconChevronRight16x16 aria-hidden="true" className="ml-cc-0.5char w-3 h-3 md:w-4 md:h-4 transform-gpu -translate-y-px"/>
              </span> :
              <a href="/"
                 className="text-cc-body-medium sm:text-cc-body-large transition-colors duration-200 ease-linear group inline-flex items-center text-cc-accent font-semibold hover:text-cc-accent-60"
                 onClick={computedNextPageLinkClickFn}>
                <span className="transition-colors duration-200 border-b border-transparent group-hover:border-cc-accent">{translatedNextLabel}</span>
                <CCIconChevronRight16x16 aria-hidden="true" className="ml-cc-0.5char w-3 h-3 md:w-4 md:h-4 transform-gpu -translate-y-px"/>
              </a>
          }
        </li>
      </ul>
    </ComputedComponentTagName>
  );
}
